const React = require("react");
// Using CommonJS syntax because of conditional require in the PluginCard Component

const DusmSVG = props => (
  <svg
    className="logo"
    width="100%"
    height="100%"
    viewBox="0 0 49 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: `evenodd`,
      clipRule: `evenodd`,
      strokeLinejoin: `round`,
      strokeMiterlimit: `2`,
    }}
  >
    <g transform="matrix(1,0,0,1,-54,-30)">
      <g transform="matrix(0.90566,0,0,0.941176,54.9901,-10.4706)">
        <rect x="0" y="43" width="53" height="51" style={{ fill: `none` }} />
        <clipPath id="_clip1">
          <rect x="0" y="43" width="53" height="51" />
        </clipPath>
        <g
          id="Fill-ONLY"
          transform="matrix(1.08116,0,0,1.04036,0.552083,1.91667)"
        >
          <path
            d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52Z"
            style={props ? { fill: props.backgroundcolor } : {}}
            className="logo-frame-fill"
          />
        </g>
        <g clipPath="url(#_clip1)">
          <g transform="matrix(1.10417,0,0,1.0625,0,0.5)">
            <path
              d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52ZM46.5,52L46.5,76C46.5,81.795 41.795,86.5 36,86.5C36,86.5 12,86.5 12,86.5C6.205,86.5 1.5,81.795 1.5,76L1.5,52C1.5,46.205 6.205,41.5 12,41.5C12,41.5 36,41.5 36,41.5C41.795,41.5 46.5,46.205 46.5,52Z"
              className="logo-frame"
              style={props ? { fill: props.color } : {}}
            />
          </g>

          <g transform="matrix(1.15736,0,0,1.11368,-0.26581,41.8228)">
            <g transform="matrix(0.956086,0,0,0.720706,19.0787,5.10418)">
              <path
                d="M2.569,39.854L10.605,13.609L18.642,39.854L2.569,39.854Z"
                className="logo-color-transparency"
                style={
                  props ? { fill: props.color, fillOpacity: props.opacity } : {}
                }
              />
            </g>
            <g transform="matrix(0.954043,0,0,0.954043,-52.2332,-27.5643)">
              <path
                d="M78.99,55.637L85.375,39.918L96.003,66.082L61.977,66.082L72.605,39.918L78.99,55.637ZM78.055,57.939L72.605,44.523L64.552,64.349L75.451,64.349L78.055,57.939ZM85.375,44.523L77.322,64.349L93.429,64.349L85.375,44.523Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

exports.Logo = DusmSVG;
